<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <div class="level">
        <div class="level-left">
          <h1 class="title is-5">{{ $t('routes.employeeExecutionReport') }}</h1>
        </div>
        <div class="level-right">
          <div class="control">
            <button @click="loadData(true)" class="button is-success">{{ $t('interface.exportExcel') }}</button>
          </div>
        </div>
      </div>
      <div class="level">
        <div class="level-left">
          <div class="field controls is-grouped">
            <div class="control">
              <b-field :label="$t('reports.startDate')">
                <b-datepicker v-model="startDate"
                              @input="loadData()"
                              :month-names="$locale.datePicker().month"
                              :day-names="$locale.datePicker().days"
                              icon="calendar-today">
                </b-datepicker>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile-scroll">
        <table class="report-table">
          <thead>
          <tr>
            <td rowspan="2" width="60" class="has-text-centered">№</td>
            <td rowspan="2">{{ $t('reports.fullname') }}</td>
            <td rowspan="2" width="140">{{ $t('reports.documentsTasks') }}</td>
            <td colspan="2" class="has-text-centered">{{ $t('reports.notStarted') }}</td>
            <td colspan="2" class="has-text-centered">{{ $t('reports.inProgress') }}</td>
            <td colspan="2" class="has-text-centered">{{ $t('reports.done') }}</td>
            <td colspan="2" class="has-text-centered">{{ $t('reports.closed') }}</td>
          </tr>
          <tr>
            <td width="100">{{ $t('reports.total') }}</td>
            <td width="100">{{ $t('reports.expired') }}</td>
            <td width="100">{{ $t('reports.total') }}</td>
            <td width="100">{{ $t('reports.expired') }}</td>
            <td width="100">{{ $t('reports.total') }}</td>
            <td width="100">{{ $t('reports.expired') }}</td>
            <td width="100">{{ $t('reports.total') }}</td>
            <td width="100">{{ $t('reports.expired') }}</td>
          </tr>
          </thead>
          <tbody>
          <template v-for="department in employeeExecutionDataByDepartment"
                    v-if="department">
            <tr>
              <td colspan="11" class="has-text-centered">{{department.name}}</td>
            </tr>
            <template v-for="(employee, n) in department.items">
              <tr>
                <td rowspan="2" class="has-text-centered">{{ n + 1 }}</td>
                <td rowspan="2">
                  <a @click="userDetail(employee.id)">{{ employee.fullname }}</a><br>
                  <span class="has-text-grey-light">{{ employee.position__post_name }}</span>
                </td>
                <td>
                  {{ $t('reports.documents') }}
                  <span class="has-text-grey-light">({{ employee.docs }})</span>
                </td>
                <td>{{ employee.docs_new }}</td>
                <td>{{ employee.docs_new_expired }}</td>
                <td>{{ employee.docs_in_process }}</td>
                <td>{{ employee.docs_in_process_expired }}</td>
                <td>{{ employee.docs_done }}</td>
                <td>{{ employee.docs_done_expired }}</td>
                <td>{{ employee.docs_closed }}</td>
                <td>{{ employee.docs_closed_expired }}</td>
              </tr>
              <tr>
                <td>
                  {{ $t('reports.tasks') }}
                  <span class="has-text-grey-light">({{ employee.tasks }})</span>
                </td>
                <td>{{ employee.tasks_new }}</td>
                <td>{{ employee.tasks_new_expired }}</td>
                <td>{{ employee.tasks_in_process }}</td>
                <td>{{ employee.tasks_in_process_expired }}</td>
                <td>{{ employee.tasks_done }}</td>
                <td>{{ employee.tasks_done_expired }}</td>
                <td>{{ employee.tasks_closed }}</td>
                <td>{{ employee.tasks_closed_expired }}</td>
              </tr>
            </template>
          </template>
          <template v-if="employeeExecutionDataByDepartment.length === 0">
            <tr>
              <td colspan="11">
                <section class="section">
                  <div class="content is-fluid has-text-grey has-text-centered">
                    {{ $t('reports.nothingFound') }}
                  </div>
                </section>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {mapGetters, mapState} from 'vuex'
  import {prepareDate, userDetail, objectToURLParams, outputFile} from '@/utils'
  import {API_HOST} from '@/localSettings'

  let startDate = new Date()

  startDate.setDate(1)

  export default {
    components: {
      DashboardLayout
    },
    data() {
      return {
        startDate,
      }
    },
    methods: {
      userDetail,
      goTo(route) {
        this.$router.push({name: route})
      },
      loadData(excel = false) {
        this.$store.dispatch('Reports/getEmployeeExecution', {
          export: excel,
          start_date: prepareDate(this.startDate),
        }).then(() => {
          if(excel) {
            outputFile('report.xlsx', this.exportData)
          }
        })
      }
    },
    mounted() {
      this.$store.commit('Reports/CLEAR', 'employeeExecutionData')
      this.loadData()
    },
    computed: {
      ...mapGetters('Reports', ['employeeExecutionDataByDepartment', 'exportData']),
      ...mapState('Reports', ['exportData']),
      breadcrumbs() {
        return [
          {name: 'reportsList', path: 'reportsList'},
          {name: 'employeeExecutionReport'}
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
